import React, { useEffect, useRef } from 'react';
import { X } from 'lucide-react';

/**
 * Auto-dismissing toast notification with optional action button.
 * Used for undo operations (e.g., "Not Interested" undo).
 */
const Toast = ({ message, actionLabel, onAction, onDismiss, duration = 5000 }) => {
  const timerRef = useRef(null);

  useEffect(() => {
    timerRef.current = setTimeout(() => {
      onDismiss?.();
    }, duration);

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [duration, onDismiss]);

  const handleAction = () => {
    if (timerRef.current) clearTimeout(timerRef.current);
    onAction?.();
  };

  const handleClose = () => {
    if (timerRef.current) clearTimeout(timerRef.current);
    onDismiss?.();
  };

  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50 animate-in slide-in-from-bottom-4">
      <div className="flex items-center gap-3 px-4 py-3 bg-gray-900 text-white rounded-lg shadow-lg min-w-[300px]">
        <span className="text-sm flex-1">{message}</span>
        {actionLabel && (
          <button
            onClick={handleAction}
            className="text-sm font-medium text-primary-400 hover:text-primary-300 transition-colors whitespace-nowrap"
          >
            {actionLabel}
          </button>
        )}
        <button
          onClick={handleClose}
          className="text-gray-400 hover:text-white transition-colors"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default Toast;
